import Header from '../Components/Header'
import Footer from '../Components/Footer'
import EventImages from '../Components/EventImages'

function EventPhotos() {
  return (
    <>
      <Header />
      <EventImages />
      <Footer />
    </>
  )
}

export default EventPhotos
